module.exports = __webpack_public_path__ + "img/hero-image3.b65e43cb.jpg";